import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-ds-slot-booking',
  templateUrl: './ds-slot-booking.component.html',
  styleUrls: ['./ds-slot-booking.component.scss']
})
export class DsSlotBookingComponent implements OnInit {
  selectedTimeSlot: any;
  availableTimeSlots: any[] = [
    '6Am - 7Am',
    '7Am - 8Am',
    '8Am - 9Am',
    '9Am - 10Am',
    '10Am - 11Am',
    '11Am - 12Pm',
    '1Pm - 2Pm',
    '2Pm - 3Pm',
    '3Pm - 4Pm',
    '4Pm - 5Pm',
    '5Pm - 6Pm',
    '6Pm - 7Pm',
    '7Pm - 8Pm',
    '8Pm - 9Pm',
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
